"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBWeddingNegative = function SvgBWeddingNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M49.072 143.58a48.4 48.4 0 1112.855-95.067 2.097 2.097 0 01-1.111 4.026C40.273 46.887 18.62 56.689 9.31 75.853 0 95.017 5.68 118.095 22.82 130.75c17.14 12.655 40.869 11.288 56.443-3.252 15.574-14.54 18.565-38.118 7.116-56.086a2.098 2.098 0 113.537-2.258 48.408 48.408 0 01-39.845 74.405l-1 .02z"
  }), (0, _core.jsx)("path", {
    d: "M49.093 132.648c-20.557.013-37.286-16.539-37.49-37.094-.206-20.556 16.189-37.438 36.742-37.835 1.153 0 2.307 0 3.446.084a2.102 2.102 0 01-.294 4.194 32.005 32.005 0 00-3.068-.084c-15.265.313-28.357 10.976-31.753 25.86-3.396 14.886 3.777 30.172 17.396 37.074 13.619 6.901 30.187 3.647 40.183-7.894 9.996-11.54 10.853-28.404 2.079-40.899a2.1 2.1 0 013.432-2.418 37.482 37.482 0 01-29.911 59.005l-.762.007z"
  }), (0, _core.jsx)("path", {
    d: "M95.117 142.65c-3.092.001-6.177-.291-9.213-.873a2.097 2.097 0 11.797-4.117 44.256 44.256 0 0052.622-44.298c-.388-18.572-12.346-34.92-29.928-40.915-17.582-5.996-37.037-.36-48.692 14.105-11.654 14.465-13.023 34.673-3.425 50.577a2.097 2.097 0 11-3.586 2.174c-11.33-18.75-8.656-42.774 6.523-58.573 15.178-15.799 39.075-19.434 58.264-8.863 19.19 10.57 28.888 32.711 23.646 53.983-5.243 21.272-24.119 36.372-46.022 36.815l-.986-.014z"
  }), (0, _core.jsx)("path", {
    d: "M95.837 131.718a2.097 2.097 0 01-.042-4.194c15.28-.302 28.392-10.97 31.795-25.87 3.403-14.899-3.777-30.201-17.41-37.107-13.635-6.906-30.22-3.64-40.218 7.918-9.998 11.559-10.842 28.441-2.044 40.938a2.1 2.1 0 01-3.433 2.42c-9.91-14.07-8.967-33.08 2.287-46.098 11.254-13.02 29.928-16.702 45.282-8.93 15.354 7.77 23.444 24.999 19.617 41.777-3.826 16.778-18.587 28.794-35.792 29.14l-.042.006zM71 40.649a2.097 2.097 0 01-1.447-.58L50.722 21.976A12.513 12.513 0 0164.45 1.517a2.097 2.097 0 11-1.698 3.83 8.318 8.318 0 00-9.13 13.604l18.832 18.098A2.097 2.097 0 0171 40.656v-.007zM77.592 33.777a2.097 2.097 0 01-1.51-3.551l11.485-11.953a8.325 8.325 0 00-.237-11.758 8.304 8.304 0 00-11.758.238L72.28 10.17a2.097 2.097 0 11-3.02-2.901l3.285-3.425c4.785-4.982 12.704-5.142 17.686-.357 4.982 4.785 5.141 12.703.356 17.686l-11.499 11.96a2.097 2.097 0 01-1.496.643z"
  })));
};

var _default = SvgBWeddingNegative;
exports["default"] = _default;